import store from "../../../store";
import wolt_export from './wolt_export.vue';

window.wolt_export =  new Vue({
    store,
    el: 'div#wolt_export',

    name : "wolt_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        wolt_export,
    }
});
